import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { DeviceType, useDeviceType } from '../../hooks';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var MobileContent = styled.div.withConfig({
  displayName: "responsive__MobileContent",
  componentId: "sc-1yrusap-0"
})(["display:none;", ";"], function (props) {
  return props.theme.media.mobile(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n  "])));
});
var DesktopContent = styled.div.withConfig({
  displayName: "responsive__DesktopContent",
  componentId: "sc-1yrusap-1"
})(["display:none;", ""], function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "])));
});

var MobileScreen = function MobileScreen(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible;
  var deviceType = useDeviceType();

  if (isVisible) {
    return /*#__PURE__*/_jsx(MobileContent, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    });
  }

  return deviceType === DeviceType.mobile ? children : null;
};

var DesktopScreen = function DesktopScreen(_ref2) {
  var children = _ref2.children,
      isVisible = _ref2.isVisible;
  var deviceType = useDeviceType();

  if (isVisible) {
    return /*#__PURE__*/_jsx(DesktopContent, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    });
  }

  return deviceType === DeviceType.desktop ? children : null;
};

export var Responsive = {
  MobileScreen: MobileScreen,
  DesktopScreen: DesktopScreen
};